import React from 'react';

import {GenericNewElementPage} from 'app/components/general/GenericNewElementPage';
import {useCurrentUserState} from 'app/current-user/api';
import {getCurrentUserPerms} from 'app/current-user/utils';
import {useCreateQuiz} from 'app/quizzes/api';
import {gt} from 'app/utils/i18n';

import type {TeamSerializedType} from 'sweet-types';

export const NewQuizPage = () => {
  const [createQuiz] = useCreateQuiz();
  const permsMap = getCurrentUserPerms(useCurrentUserState().data!);
  const disableText = gt(
    'You must be the manager of a team to create quizzes.'
  );
  const handleDisableTeamText = (team: TeamSerializedType) =>
    gt('You must be the manager of the %s team', team.name);

  return (
    <GenericNewElementPage
      elementName={'quiz'}
      createNewDocument={(args) => createQuiz(args).unwrap()}
      disableFolder={true}
      forceDisableConfirm={!permsMap.isManager}
      disabledTooltip={!permsMap.isManager ? disableText : undefined}
      disabledTeamText={!permsMap.isManager ? handleDisableTeamText : undefined}
    />
  );
};
